import { useMemo } from 'react';
import { apiClient } from '../../../api/client';
import { url as apiUrl } from '../../../api';
import { getAuthToken } from '../../../utils/authTokens';
import { COFFEE_API_BASE } from '../../coffee_card_web/api/paths';
import { useLocalCache, UseLocalCacheResult } from '../utils/swrCache';

const url = apiUrl || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export interface NearbyAlternative {
    shopId: string;
    name: string;
    distanceMeters: number;
    avgRating: number;
    ratingCount: number;
    hasUserRated: boolean;
}

export type NearbyAlternativesResponse = NearbyAlternative[];

export function useNearbyAlternatives(shopId: string | undefined): UseLocalCacheResult<NearbyAlternativesResponse> {
    const key = shopId ? `coffee_shop_alternatives_${shopId}` : null;

    const fetcher = useMemo(
        () => async () => {
            const token = getAuthToken();
            const response = await apiClient.get<NearbyAlternativesResponse>(
                `${url}${COFFEE_API_BASE}/shops/${shopId}/nearby-alternatives`,
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
            );
            return Array.isArray(response.data) ? response.data : [];
        },
        [shopId]
    );

    return useLocalCache<NearbyAlternativesResponse>(key, 5 * 60 * 1000, fetcher);
}
